import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useState } from 'react';
import { FormProvider } from './context/FormContext';
import { FormProgress } from './components/FormProgress';
import { FormSteps } from './components/FormSteps';
var App = function () {
    var _a, _b;
    var formTitle = ((_b = (_a = window.tiofSettings) === null || _a === void 0 ? void 0 : _a.formConfig) === null || _b === void 0 ? void 0 : _b.title) || 'Trade In Offer Form';
    var formWrapperRef = useRef(null);
    var _c = useState(false), disablePreviousSteps = _c[0], setDisablePreviousSteps = _c[1];
    return (_jsx(FormProvider, { children: _jsxs("div", { className: "tiof-form-wrapper", ref: formWrapperRef, children: [_jsx(FormProgress, { disablePreviousSteps: disablePreviousSteps }), _jsx(FormSteps, { formWrapperRef: formWrapperRef, setDisablePreviousSteps: setDisablePreviousSteps })] }) }));
};
export default App;
